import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'nominas/historico-retenciones-de-pagos-empleados';

/**
 * GET Historicos Retenciones de Pagos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getHistoricosRetencionesDePagos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Historico Retencion de Pago
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getHistoricoRetencionDePago = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Historico Retencion de Pago
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistoricoRetencionDePago = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * PATCH Historico Retencion de Pago
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistoricoRetencionDePago = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return false;
};

/**
 * DELETE Historico Retencion de Pago
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteHistoricoRetencionDePago = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
  }
  return false;
};
